import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserFormComponent } from '../../users/user-form/user-form.component';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-admin-form',
  template: `
    <app-user-form
      [forceProfil]="'NexusAdministrateur'"
      [readOnlyProfilSelection]="true"
      [adminMode]="true"
    ></app-user-form>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule, UserFormComponent],
})
export class AdminFormComponent {}
